import axios from 'axios';
import lifeEventsData from '../data/life_events.json';

const API_URL = process.env.REACT_APP_API_URL
const STATIC_WEBSITE = process.env.REACT_APP_STATIC_WEBSITE === 'True'

const LifeEventService = {
    getAllLifeEvent: async () => {
        try {
            if (STATIC_WEBSITE) {
                return lifeEventsData;
            } else {
                const response = await axios.get(`${API_URL}/life-events/`);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching life events:', error);
            throw error;
        }
    },
};

export default LifeEventService;